import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { CountertopUniversity } from "../types/CountertopUniversity";

export const useGetCountertopUniversity = (
    parentCompanyID: number | null,
    profileID: number | null,
    enabled = true
) => {
    return useQuery<CountertopUniversity>({
        queryKey: ['countertop-university', parentCompanyID, profileID],
        queryFn: () => apiClient.get("countertop-university", {
            params: { parentCompanyID, profileID }
        }),
        enabled,
    });
};